import { useCurrentUser } from '@/hooks';
import { Capacitor } from '@capacitor/core';
import { useEffect } from 'react';
import { useUpdateUserPushSubscriptionMutation } from './graphql.generated';
import { getNotificationPermission } from './register';
import { useServiceWorker } from './use-worker';

export const WebPushNotificationManager = () => {
	const { currentUser } = useCurrentUser();
	const serviceWorker = useServiceWorker();
	const [updateUserPushSubscription] = useUpdateUserPushSubscriptionMutation();

	useEffect(() => {
		const clickListener = async () => {
			// Make sure we're not on the app before registering for notifications
			if (currentUser && !Capacitor.isNativePlatform() && (await getNotificationPermission())) {
				const clientSubscription = await serviceWorker.vapidDetails();
				// NOTE: This model of update means that the newest subscription will always be used. For example, if
				// the user logs into their account on two different devices, the subscription on the newest device will
				// be used.
				if (
					clientSubscription &&
					currentUser?.pushSubscription?.endpoint !== clientSubscription.endpoint
				) {
					await updateUserPushSubscription({
						variables: {
							input: {
								id: currentUser.id,
								pushSubscription: clientSubscription,
							},
						},
					});
				}
			}
		};

		// NOTE: Firefox only lets you register the service worker during a click event
		document.addEventListener('click', clickListener, { once: true });
		document.addEventListener('touchstart', clickListener, { once: true });
		return () => {
			document.removeEventListener('click', clickListener);
			document.removeEventListener('touchstart', clickListener);
		};
	}, [currentUser, serviceWorker, updateUserPushSubscription]);

	return null;
};
